// @flow
import defaultState from '../defaultState';
import type {
  Booking as State,
  CurrentCampaignActions as Action
} from '../types';

const defaultCurrentCampaignBooking = defaultState.currentCampaignBooking;

export default function currentCampaignBooking(
  // $FlowFixMe
  state: State = defaultCurrentCampaignBooking,
  action: Action
) {
  switch (action.type) {
    case 'UPDATE_CURRENT_CAMPAIGN_BOOKING':
      return {
        ...action.booking.booking
      };

    case 'CLEAR_CURRENT_CAMPAIGN_BOOKING':
      return defaultCurrentCampaignBooking;

    case 'LOGOUT':
      return defaultCurrentCampaignBooking;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/currentCampaignBooking.js